import { useState, useEffect, useCallback } from 'react';
import { getEhrOptionsList } from 'api/ehr';
import { TEhrOptionItem } from 'types/ehrConnection';

let globalData: TEhrOptionItem[] = [];
let globalLoaded = false;

const useEhrOptions = (): [TEhrOptionItem[], boolean, () => void] => {
    const [data, setData] = useState<TEhrOptionItem[]>(globalData);
    const [loading, setLoading] = useState(!globalLoaded);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const res = await getEhrOptionsList();
            if (res && !res.error) {
                const list = res.data?.data || [];
                globalData = list;
                globalLoaded = true;
                setData(list);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (!globalLoaded) {
            fetchData();
        }
    }, [fetchData]);

    return [data, loading, fetchData];
};

export default useEhrOptions;
